import { render, staticRenderFns } from "./MapSettings.vue?vue&type=template&id=4d52ee39"
import script from "./MapSettings.vue?vue&type=script&lang=js"
export * from "./MapSettings.vue?vue&type=script&lang=js"
import style0 from "./MapSettings.vue?vue&type=style&index=0&id=4d52ee39&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports